import { AqiType } from '../enums/aqi.type';

export const AQI_WITH_DETAILS = [AqiType.CAPI, AqiType.R, AqiType.EU];
